import { WidgetTypes } from '@amusnet/react-ui'
import { BaseComponentState } from 'game-ui-types'
import { create } from 'zustand'

export interface ComponentStoreState extends BaseComponentState {
    setComponentStates: (newStates: Partial<BaseComponentState>) => void
    isExternalUIComponentActive: boolean
    setIsExternalUIComponentActive: (value: boolean) => void
    currentAvailablePromoWidgets: WidgetTypes[]
    setCurrentAvailablePromoWidgets: (currentAvailablePromoWidgets: WidgetTypes[]) => void
    isAutomaticComponentVisibilityManagementEnabled: boolean
    setIsAutomaticComponentVisibilityManagementEnabled: (value: boolean) => void
}

export const useComponentStatesStore = create<ComponentStoreState>((set) => ({
    isBuyBonusComponentActive: true, // the field is obsolete and can be removed with the next game-ui-types update
    isComplianceComponentActive: true,
    isDoubleChanceButtonComponentActive: false,
    isJackpotCardsComponentActive: true,
    isPlayerInfoComponentActive: true,
    isMainButtonsComponentActive: true,
    isInfoLineComponentActive: true,

    setComponentStates: (newStates: Partial<BaseComponentState>) => {
        set((states) => ({ ...states, ...newStates }))
    },

    isExternalUIComponentActive: true,
    setIsExternalUIComponentActive: (value) => set({ isExternalUIComponentActive: value }),

    currentAvailablePromoWidgets: [],
    setCurrentAvailablePromoWidgets: (currentAvailablePromoWidgets: WidgetTypes[]) =>
        set({ currentAvailablePromoWidgets }),

    isAutomaticComponentVisibilityManagementEnabled: true,
    setIsAutomaticComponentVisibilityManagementEnabled: (value) =>
        set({ isAutomaticComponentVisibilityManagementEnabled: value }),
}))
